import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: CultureCreateInput!
  ) {
    createOneCulture(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Cultura criada`, mutationTypes.CREATE)
)
